import { render, staticRenderFns } from "./CoreValuesThreeIcon.vue?vue&type=template&id=7d282d70&"
import script from "./CoreValuesThreeIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesThreeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports